/**
 * Object describing what state a request is in.
 * @enum {string}
 */
export const LoadingState = {
    INITIAL: 'initial',
    LOADING: 'loading',
    SUCCESS: 'success',
    FAILURE: 'failure',
};
